import React from 'react';
import PatientFormTemplate from './components/PatientFormTemplate';

export default function PatientPsychiatricHistoryForm() {
    return (
        <PatientFormTemplate formTitle="Your Wellbeing" />
    );
}